var React = require('react');

function Gprs (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.382 9.808v5.958q-.831.995-2.349 1.543-1.517.549-3.363.549-1.938 0-3.399-.846t-2.256-2.456q-.794-1.61-.815-3.784V9.757q0-2.235.754-3.871.753-1.635 2.173-2.502 1.421-.866 3.328-.866 2.656 0 4.153 1.266 1.497 1.267 1.774 3.687h-2.994q-.206-1.282-.908-1.877-.702-.595-1.933-.595-1.569 0-2.389 1.18-.82 1.179-.831 3.506v.954q0 2.348.893 3.548.892 1.2 2.614 1.2 1.733 0 2.471-.739v-2.573H7.506V9.808h5.876zM15 10.75V6h1.9v4.75H15zm0 3.8v-1.9h1.9v1.9H15z","fill":"currentColor"}));
}

Gprs.defaultProps = {"viewBox":"0 0 18 20"};

module.exports = Gprs;

Gprs.default = Gprs;
